import axios from "../axiosInstance";
import { FetchStochasticInvoicesRequest } from "./types";

export const fetchStochasticInvoicesCsv = async (
  requestParams: FetchStochasticInvoicesRequest = {},
): Promise<Blob> => {
  const response = await axios.get<Blob>(`/api/private/stochastic-invoices`, {
    responseType: "blob",
    headers: {
      Accept: "text/csv",
    },
    params: {
      ...requestParams,
      format: "csv",
    },
  });

  return response.data;
};
